import { availableItemUnits, selectionTotals } from './invoiceSelection';
import type { SelectionUnit } from './invoiceSelection';
import { invoiceableLines } from './invoiceableLines';
import type { InvoiceableService } from './invoiceableLines';
import type { SoldAddOn, SoldLines } from '../types/agreements.types';

export interface NextService {
    service: InvoiceableService;
    gross: number;
}

const earliestBySequence = (services: InvoiceableService[]): InvoiceableService | undefined =>
    services.reduce<InvoiceableService | undefined>(
        (earliest, service) => (earliest === undefined || service.sequence < earliest.sequence ? service : earliest),
        undefined,
    );

const serviceUnits = (service: InvoiceableService): SelectionUnit[] =>
    service.partlyInvoiced ? availableItemUnits(service) : [{ kind: 'service', serviceId: service.id }];

const linkedAddOnUnits = (addOns: SoldAddOn[], serviceId: string): SelectionUnit[] =>
    addOns
        .filter((addOn) => addOn.linkedServiceId === serviceId)
        .map((addOn) => ({ kind: 'add_on', addOnId: addOn.id }));

export function nextService(lines: SoldLines): NextService | null {
    const { services, addOns } = invoiceableLines(lines);
    const service = earliestBySequence(services);
    if (!service) return null;

    const units = [...serviceUnits(service), ...linkedAddOnUnits(addOns, service.id)];
    return { service, gross: selectionTotals(units, lines).gross };
}
